var webooker_acivity_models = webooker_acivity_models || {};

(function (ns) {

    // #region InvoiceBase - Ctor 
    ns.InvoiceBase = function InvoiceBase(isReccuring) {
        this.isReccuring = isReccuring;
    }
    // #endregion

    // #region InvoiceBase - Methods

    ns.InvoiceBase.prototype.resetFields = function () {
        this.invoiceLineKindergartenCustomUnitPrice = 0;
        this.invoiceLineKindergartenOneOffUnitPrice = 0;

        if (this._invoiceLineKindergartenLunchQty) {
            delete (this._invoiceLineKindergartenLunchQty);
        }

        if (this._invoiceLineKindergartenSnackQty) {
            delete (this._invoiceLineKindergartenSnackQty);
        }

        if (this._invoiceLineKindergartenLatePickupQty) {
            delete (this._invoiceLineKindergartenLatePickupQty);
        }
    }

    ns.InvoiceBase.prototype.initLocalization = function ($translate) {
        this.invoiceLineKindergartenFeeName = $translate.instant('TXT_LBL_ACTIVITY_FEE');
        this.invoiceLineKindergartenFeeReccuringName = $translate.instant('TXT_LBL_ACTIVITY_FEE');
        this.invoiceLineKindergartenOneOffName = $translate.instant('TXT_LBL_ACTIVITY_ONE_OFF_FEE');
        this.invoiceLineKindergartenLunchName = $translate.instant('TXT_LBL_ACTIVITY_LUNCH');
        this.invoiceLineKindergartenSnackName = $translate.instant('TXT_LBL_ACTIVITY_SNACK');
        this.invoiceLineKindergartenLatePickupName = $translate.instant('TXT_LBL_ACTIVITY_LATE_PICKUP');
        this.invoiceLineKindergartenCustomName = $translate.instant('TXT_LBL_ACTIVITY_OTHER');
    }

    ns.InvoiceBase.prototype.initDataByInvoiceDTO = function (invoiceDTO) {
        if (invoiceDTO) {
            this.invoiceID = invoiceDTO.invoiceID;
            this.invoiceDate = invoiceDTO.invoiceDate;
            this.operatorID = invoiceDTO.customerOperatorID;
            this.accountingBookID = invoiceDTO.accountingBookID;
            this.taxDate = invoiceDTO.taxDate;
            this.isVATPayer = invoiceDTO.isVATPayer;

            if (invoiceDTO.lineItems) {
                for (var i = 0; i < invoiceDTO.lineItems.length; i++) {
                    var li = invoiceDTO.lineItems[i];
                    switch (li.invoiceLineType) {
                        case 'ActivitySnack':
                            this.invoiceLineKindergartenSnackName = li.name;
                            this.invoiceLineKindergartenSnackQty = li.quantity;
                            this.invoiceLineKindergartenSnackUnitPrice = li.unitPrice || 0;
                            break;
                        case 'ActivityLunch':
                            this.invoiceLineKindergartenLunchName = li.name;
                            this.invoiceLineKindergartenLunchQty = li.quantity;
                            this.invoiceLineKindergartenLunchUnitPrice = li.unitPrice || 0;
                            break;
                        case 'ActivityLatePickup':
                            this.invoiceLineKindergartenLatePickupName = li.name;
                            this.invoiceLineKindergartenLatePickupQty = li.quantity;
                            this.invoiceLineKindergartenLatePickupUnitPrice = li.unitPrice || 0;
                            break;
                        case 'ActivityFee':
                            this.invoiceLineKindergartenFeeName = li.name;
                            this.invoiceLineKindergartenFeeQty = (li.quantity == null)
                                ? 1
                                : li.quantity;
                            this.invoiceLineKindergartenFeeUnitPrice = li.unitPrice || li.price;
                            break;
                        case 'ActivityFeeReccuring':
                            this.invoiceLineKindergartenFeeReccuringName = li.name;
                            this.invoiceLineKindergartenFeeReccuringQty = (li.quantity == null)
                                ? 1
                                : li.quantity;
                            this.invoiceLineKindergartenFeeReccuringUnitPrice = li.unitPrice || li.price;
                            break;
                        case 'ActivityOneOffFee':
                            this.invoiceLineKindergartenOneOffName = li.name;
                            this.invoiceLineKindergartenOneOffQty = (li.quantity == null)
                                ? ((!li.price) ? 0 : 1)
                                : li.quantity;
                            this.invoiceLineKindergartenOneOffUnitPrice = li.unitPrice || li.price;
                            break;
                        case 'ManualAdjustment':
                            this.invoiceLineKindergartenCustomName = li.name;
                            this.invoiceLineKindergartenCustomQty = (li.quantity == null)
                                ? ((!li.price) ? 0 : 1)
                                : li.quantity;
                            this.invoiceLineKindergartenCustomUnitPrice = li.unitPrice || li.price;
                            break;
                        default:
                            alert('Unknown invoice line type: ' + li.invoiceLineType);
                            break;
                    }
                }
            }
        }
        this.invoiceLineKindergartenSnackUnitPrice = this.invoiceLineKindergartenSnackUnitPrice || 0;
        if (!!this.invoiceLineKindergartenSnackUnitPrice) {
            this.invoiceLineKindergartenSnackQty = this.invoiceLineKindergartenSnackQty || 1;
        }

        this.invoiceLineKindergartenLunchUnitPrice = this.invoiceLineKindergartenLunchUnitPrice || 0;
        if (!!this.invoiceLineKindergartenLunchUnitPrice) {
            this.invoiceLineKindergartenLunchQty = this.invoiceLineKindergartenLunchQty || 1;
        }

        this.invoiceLineKindergartenLatePickupUnitPrice = this.invoiceLineKindergartenLatePickupUnitPrice || 0;
        if (!!this.invoiceLineKindergartenLatePickupUnitPrice) {
            this.invoiceLineKindergartenLatePickupQty = this.invoiceLineKindergartenLatePickupQty || 1;
        }

        this.invoiceLineKindergartenFeeUnitPrice = this.invoiceLineKindergartenFeeUnitPrice || 0;
        this.invoiceLineKindergartenFeeQty = this.invoiceLineKindergartenFeeQty || 0;

        this.invoiceLineKindergartenFeeReccuringUnitPrice = this.invoiceLineKindergartenFeeReccuringUnitPrice || 0;
        this.invoiceLineKindergartenFeeReccuringQty = this.invoiceLineKindergartenFeeReccuringQty || 0;

        this.invoiceLineKindergartenOneOffUnitPrice = this.invoiceLineKindergartenOneOffUnitPrice || 0;
        this.invoiceLineKindergartenOneOffQty = this.invoiceLineKindergartenOneOffQty || 0;

        this.invoiceLineKindergartenCustomUnitPrice = this.invoiceLineKindergartenCustomUnitPrice || 0;
        this.invoiceLineKindergartenCustomQty = this.invoiceLineKindergartenCustomQty || 0;


    }

    ns.InvoiceBase.prototype.getInvoiceDTO = function ($translate) {
        var res = { lineItems: [] } ;

        res.invoiceID = this.invoiceID;
        res.total = this.invoiceSumPrice;
        res.customerStudentID = this.studentID;
        res.customerOperatorID = this.operatorID;
        res.accountingBookID = this.accountingBookID;
        res.invoiceDate = this.invoiceDate || new Date();
        res.taxDate = this.taxDate;

        if (this.invoiceLineKindergartenSnackPrice) {
            res.lineItems.push({
                invoiceLineType: 'ActivitySnack',
                name: this.invoiceLineKindergartenSnackName,
                price: this.invoiceLineKindergartenSnackPrice,
                quantity: this.invoiceLineKindergartenSnackQty,
                unitPrice: this.invoiceLineKindergartenSnackUnitPrice
            });
        }

        if (this.invoiceLineKindergartenLunchPrice) {
            res.lineItems.push({
                invoiceLineType: 'ActivityLunch',
                name: this.invoiceLineKindergartenLunchName,
                price: this.invoiceLineKindergartenLunchPrice,
                quantity: this.invoiceLineKindergartenLunchQty,
                unitPrice: this.invoiceLineKindergartenLunchUnitPrice
            });
        }

        if (this.invoiceLineKindergartenLatePickupPrice) {
            res.lineItems.push({
                invoiceLineType: 'ActivityLatePickup',
                name: this.invoiceLineKindergartenLatePickupName,
                price: this.invoiceLineKindergartenLatePickupPrice,
                quantity: this.invoiceLineKindergartenLatePickupQty,
                unitPrice: this.invoiceLineKindergartenLatePickupUnitPrice
            });
        }

        // Always add activity fee line, even if 0
        if (!this.isReccuring) {
            res.lineItems.push({
                invoiceLineType: 'ActivityFee',
                name: this.invoiceLineKindergartenFeeName || $translate.instant('TXT_LBL_ACTIVITY_FEE'),
                price: this.invoiceLineKindergartenFeePrice || 0,
                quantity: this.invoiceLineKindergartenFeeQty || 0,
                unitPrice: this.invoiceLineKindergartenFeeUnitPrice || 0
            });
        } else {
            res.lineItems.push({
                invoiceLineType: 'ActivityFeeReccuring',
                name: this.invoiceLineKindergartenFeeReccuringName || $translate.instant('TXT_LBL_ACTIVITY_FEE'),
                price: this.invoiceLineKindergartenFeeReccuringPrice || 0,
                quantity: this.invoiceLineKindergartenFeeReccuringQty || 0,
                unitPrice: this.invoiceLineKindergartenFeeReccuringUnitPrice || 0
            });
        }

        if (this.invoiceLineKindergartenOneOffPrice) {
            res.lineItems.push({
                invoiceLineType: 'ActivityOneOffFee',
                name: this.invoiceLineKindergartenOneOffName,
                price: this.invoiceLineKindergartenOneOffPrice || 0,
                quantity: this.invoiceLineKindergartenOneOffQty || 0,
                unitPrice: this.invoiceLineKindergartenOneOffUnitPrice || 0
            });
        }

        if (this.invoiceLineKindergartenCustomPrice) {
            res.lineItems.push({
                invoiceLineType: 'ManualAdjustment',
                name: this.invoiceLineKindergartenCustomName,
                price: this.invoiceLineKindergartenCustomPrice || 0,
                quantity: this.invoiceLineKindergartenCustomQty || 0,
                unitPrice: this.invoiceLineKindergartenCustomUnitPrice || 0
            });
        }

        return res;
    }

    // #endregion

    // #region InvoiceBase - Properties

    Object.defineProperty(ns.InvoiceBase.prototype, 'invoiceLineKindergartenFeePrice', {
        enumerable: true, configurable: true,
        get: function () {
            var notRounded = this.invoiceLineKindergartenFeeQty * this.invoiceLineKindergartenFeeUnitPrice;
            return Math.round(notRounded * 100) / 100;
        }
    });

    Object.defineProperty(ns.InvoiceBase.prototype, 'invoiceLineKindergartenFeeReccuringPrice', {
        enumerable: true, configurable: true,
        get: function () {
            var notRounded = this.invoiceLineKindergartenFeeReccuringQty * this.invoiceLineKindergartenFeeReccuringUnitPrice;
            return Math.round(notRounded * 100) / 100;
        }
    });

    Object.defineProperty(ns.InvoiceBase.prototype, 'invoiceLineKindergartenOneOffPrice', {
        enumerable: true, configurable: true,
        get: function () {
            var notRounded = this.invoiceLineKindergartenOneOffQty * this.invoiceLineKindergartenOneOffUnitPrice;
            return Math.round(notRounded * 100) / 100;
        }
    });

    Object.defineProperty(ns.InvoiceBase.prototype, 'invoiceLineKindergartenCustomPrice', {
        enumerable: true, configurable: true,
        get: function () {
            var notRounded = this.invoiceLineKindergartenCustomQty * this.invoiceLineKindergartenCustomUnitPrice;
            return Math.round(notRounded * 100) / 100;
        }
    });

    Object.defineProperty(ns.InvoiceBase.prototype, 'invoiceLineKindergartenLunchQty', {
        enumerable: true, configurable: true,
        get: function () {
            if (this._invoiceLineKindergartenLunchQty === undefined) {
                return this.noOfLunches;
            } else {
                return this._invoiceLineKindergartenLunchQty;
            }
        },
        set: function (value) {
            this._invoiceLineKindergartenLunchQty = value;
        }
    });

    Object.defineProperty(ns.InvoiceBase.prototype, 'invoiceLineKindergartenLunchPrice', {
        enumerable: true, configurable: true,
        get: function () {
            var notRounded = this.invoiceLineKindergartenLunchQty * this.invoiceLineKindergartenLunchUnitPrice;
            return Math.round(notRounded * 100) / 100;
        }
    });

    Object.defineProperty(ns.InvoiceBase.prototype, 'invoiceLineKindergartenSnackQty', {
        enumerable: true, configurable: true,
        get: function () {
            if (this._invoiceLineKindergartenSnackQty === undefined) {
                return this.noFirstSnacks + this.noSecondSnacks;
            } else {
                return this._invoiceLineKindergartenSnackQty;
            }
        },
        set: function (value) {
            this._invoiceLineKindergartenSnackQty = value;
        }
    });

    Object.defineProperty(ns.InvoiceBase.prototype, 'invoiceLineKindergartenSnackPrice', {
        enumerable: true, configurable: true,
        get: function () {
            var notRounded = this.invoiceLineKindergartenSnackQty * this.invoiceLineKindergartenSnackUnitPrice;
            return Math.round(notRounded * 100) / 100;
        }
    });

    Object.defineProperty(ns.InvoiceBase.prototype, 'invoiceLineKindergartenLatePickupQty', {
        enumerable: true, configurable: true,
        get: function () {
            if (this._invoiceLineKindergartenLatePickupQty === undefined) {
                return this.sumLatePickupHours;
            } else {
                return this._invoiceLineKindergartenLatePickupQty;
            }
        },
        set: function (value) {
            this._invoiceLineKindergartenLatePickupQty = value;
        }
    });

    Object.defineProperty(ns.InvoiceBase.prototype, 'invoiceLineKindergartenLatePickupPrice', {
        enumerable: true, configurable: true,
        get: function () {
            var notRounded = this.invoiceLineKindergartenLatePickupQty * this.invoiceLineKindergartenLatePickupUnitPrice;
            return Math.round(notRounded * 100) / 100;
        }
    });

    Object.defineProperty(ns.InvoiceBase.prototype, 'invoiceSumPrice', {
        enumerable: true, configurable: true,
        get: function () {
            var res = Number(this.invoiceLineKindergartenSnackPrice || 0) +
                      Number(this.invoiceLineKindergartenLunchPrice || 0) +
                      Number(this.invoiceLineKindergartenOneOffPrice || 0) +
                      Number(this.invoiceLineKindergartenFeePrice || 0) +
                      Number(this.invoiceLineKindergartenFeeReccuringPrice || 0) +
                      Number(this.invoiceLineKindergartenCustomPrice || 0) +
                      Number(this.invoiceLineKindergartenLatePickupPrice || 0);

            return res;
        }
    });

    Object.defineProperty(ns.InvoiceBase.prototype, 'isInvoiceEmpty', {
        enumerable: true, configurable: true,
        get: function () {

            return !(this.invoiceLineKindergartenSnackPrice || 0) &&
                   !(this.invoiceLineKindergartenLunchPrice || 0) &&
                   !(this.invoiceLineKindergartenOneOffPrice || 0) &&
                   !(this.invoiceLineKindergartenFeePrice || 0) &&
                   !(this.invoiceLineKindergartenFeeReccuringPrice || 0) &&
                   !(this.invoiceLineKindergartenCustomPrice || 0) &&
                   !(this.invoiceLineKindergartenLatePickupPrice || 0);
        }
    });

    // #endregion

}(webooker_acivity_models));